<template>
  <div class="main-container container">
<!--    <TheHomeSectionEstimate ></TheHomeSectionEstimate>-->
<!--    <TheHomeSectionPayment ref="section1"></TheHomeSectionPayment>-->
<!--    <TheHomeSectionGuide ref="section2"></TheHomeSectionGuide>-->
<!--    <TheHomeSectionAds ref="section3"></TheHomeSectionAds>-->
<!--    <OldTheHomeSectionBrand ref="sectionBrand" :isMobile="isMobile"></OldTheHomeSectionBrand>-->
<!--    <OldTheHomeSectionMan ref="section1"></OldTheHomeSectionMan>-->
<!--    <OldTheHomeSectionWhy ref="section2"></OldTheHomeSectionWhy>-->
<!--    <TheHomeSectionHow ref="section3" :isMobile="isMobile"></TheHomeSectionHow>-->
<!--    <OldTheHomeSectionEstimate ref="section4"></OldTheHomeSectionEstimate>-->
    <TheStorageEstimateV2 :isMobile="isMobile"></TheStorageEstimateV2>
    <ThePopup/>
  </div>
</template>

<script>
// @ is an alias to /src

// import OldTheHomeSectionBrand from "@/components/home/OldTheHomeSectionBrand";
// import OldTheHomeSectionMan from "@/components/home/OldTheHomeSectionMan";
// import OldTheHomeSectionWhy from "@/components/home/OldTheHomeSectionWhy";
// import OldTheHomeSectionEstimate from "@/components/home/OldTheHomeSectionEstimate";
// import TheHomeSectionEstimate from "@/components/home/TheHomeSectionEstimate";
// import TheHomeSectionPayment from "@/components/home/TheHomeSectionPayment";
// import TheHomeSectionGuide from "@/components/home/TheHomeSectionGuide";
// import TheHomeSectionAds from "@/components/home/TheHomeSectionAds";
import ThePopup from "@/components/ThePopup";
import TheStorageEstimateV2 from "@/components/estimate/TheStorageEstimateV2";

export default {
  name: 'Home',
  components: {
    TheStorageEstimateV2,
    // TheHomeSectionEstimate,
    // TheHomeSectionPayment,
    // TheHomeSectionGuide,
    // TheHomeSectionAds,

    // OldTheHomeSectionBrand,
    // OldTheHomeSectionMan,
    // OldTheHomeSectionWhy,
    // OldTheHomeSectionEstimate,
    ThePopup
  },
  data() {
    return {
      animateSection: 0,
      isMobile: null
    }
  },
  methods: {

    // scrollEvents() {
    //   if (this.animateSection < 3) {
    //     let next = this.animateSection + 1;
    //     let nextSectionTop = this.$refs['section' + next].getBoundingClientRect().top;
    //
    //     if (nextSectionTop - (window.innerHeight/3 * 2) < 0) {
    //       // console.log(this.animateSection + 1 + ' active!');
    //       // console.log(nextSectionTop - (window.innerHeight/3 * 2));
    //       this.animateSection++;
    //       this.$refs['section' + next].startAnimate();
    //     }
    //   }
    // },

    onResize() {
      let width = window.innerWidth;

      if (width <= 768 && !this.isMobile) {
        this.isMobile = true;
      } else if (width > 768 && this.isMobile) {
        this.isMobile = false;
      }
    }
  },
  mounted() {

    // document.body.classList.add('white-header');
    document.body.classList.add('grey-bg', 'fit-page', 'no-center', 'home');
    // document.addEventListener('scroll', this.scrollEvents);
    // this.scrollEvents();

    // window.addEventListener('resize', this.onResize);
    // this.onResize();

    if (this.$route.params && this.$route.params.isLogout) {
      this.$route.params.isLogout = null;
      this.$toast.error("로그아웃 되었습니다.", { position: 'top' });
    }
  },
  unmounted() {
    // document.body.classList.remove('white-header');
    document.body.classList.remove('grey-bg', 'fit-page', 'no-center', 'home');
    document.removeEventListener('scroll', this.scrollEvents);
    // window.removeEventListener('resize', this.onResize);
  }
}
</script>

<style lang="scss">

.main-container {
  //padding-top: 70px;

  .main-section {
    overflow: hidden;
    margin: 0 auto;
  }

  //.title {
  //  font-family: SBAggroM;
  //  font-size: 55px;
  //  line-height: 1.09;
  //}
  //
  //.btn-square-border {
  //  font-size: 15px;
  //  padding: 16px 35px;
  //  border: 1px solid #000;
  //  background-color: transparent;
  //  margin-top: 90px;
  //  @include border-round(0);
  //}

  .fade-up {
    opacity: 0;
    transform: translate3d(0, 50px, 0);
    transition-duration: 1s;
    transition-property: opacity,transform;
    transition-timing-function: ease;

    &.animate {
      opacity: 1;
      transform: translateZ(0);
    }
  }

  @include respond(not-mobile) {
    .btn-main {
      transition: background-color 0.3s ease-in-out;

      &.btn-primary:hover {
        background-color: #000;
      }
      &.btn-black:hover {
        background-color: $sub-color2;
      }
    }
  }

  @include respond(not-lg-desktop) {
    //.title {
    //  font-size: 35px;
    //  line-height: 30px;
    //}

    font-size: 15px;
  }

  @include respond(tablet) {
    .main-section {
      padding-left: 30px;
      padding-right: 30px;
    }

    //.title {
    //  line-height: 1.3;
    //}

  }

  @include respond(mobile) {
    .main-section {
      padding-left: 0;
      padding-right: 0;
    }
  }

  //@include respond(xs-mobile) {
  //  br {
  //    display: none;
  //  }
  //}
}

@include respond(tablet) {
  body.fit-page {
    .main-content.main {
      display: flex;
      align-items: flex-end;
      //min-height: calc(600px + 26vw);
    }
  }
}

//@include respond(sm-height-tablet) {
//  body.fit-page {
//    .main-content.main {
//      min-height: calc(600px + 4vw);
//    }
//  }
//}
</style>
